"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabsContentPropDefs = exports.tabsRootPropDefs = exports.tabsListPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const tabsRootPropDefs = {
    asChild: index_js_1.asChildProp,
};
exports.tabsRootPropDefs = tabsRootPropDefs;
const tabsContentPropDefs = {
    asChild: index_js_1.asChildProp,
};
exports.tabsContentPropDefs = tabsContentPropDefs;
var base_tab_list_props_js_1 = require("./base-tab-list.props.js");
Object.defineProperty(exports, "tabsListPropDefs", { enumerable: true, get: function () { return base_tab_list_props_js_1.baseTabListPropDefs; } });
//# sourceMappingURL=tabs.props.js.map